import { Resource } from "@prisma/client";
import { useState } from "react";

const ImageWithFallback = ({
  resource,
  className,
}: {
  resource: Resource;
  className?: string;
}) => {
  const [images, setImages] = useState([
    <source key="webp" srcSet={resource?.webpUrl || ""} type="image/webp" />,
    <source key="jpeg" srcSet={resource?.jpegUrl || ""} type="image/jpeg" />,
  ]);

  const handleError = () => {
    if (images.length === 0) {
      return;
    }

    const currentSrcSet = [...images];
    currentSrcSet.splice(0, 1);

    setImages(currentSrcSet);
  };

  return (
    <picture className={className} onError={handleError}>
      {images}
      <img src={resource?.originalFileUrl || ""} className={className} />
    </picture>
  );
};

export default ImageWithFallback;
